import { Extension } from '@tiptap/react';

export const EscapeToFocusOut = Extension.create({
  name: 'escape-to-focus-out',
  addKeyboardShortcuts() {
    return {
      Escape: () => this.editor.commands.blur(),
    };
  },
});
